import { render } from "./documentData.vue?vue&type=template&id=34a3d782&scoped=true"
import script from "./documentData.vue?vue&type=script&lang=js"
export * from "./documentData.vue?vue&type=script&lang=js"

import "./documentData.vue?vue&type=style&index=0&id=34a3d782&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/plus.centrodeglaucoma.com/darmin-plus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a3d782"]])

export default __exports__